import { render } from "./SucursalesView.vue?vue&type=template&id=cb109d5c"
import script from "./SucursalesView.vue?vue&type=script&lang=js"
export * from "./SucursalesView.vue?vue&type=script&lang=js"

import "./SucursalesView.vue?vue&type=style&index=0&id=cb109d5c&scope=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__